/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeListInner } from './ChallengeListInner';
import {
    ChallengeListInnerFromJSON,
    ChallengeListInnerFromJSONTyped,
    ChallengeListInnerToJSON,
} from './ChallengeListInner';

/**
 * 
 * @export
 * @interface PostId200ResponseAllOf
 */
export interface PostId200ResponseAllOf {
    /**
     * 
     * @type {Array<ChallengeListInner>}
     * @memberof PostId200ResponseAllOf
     */
    result?: Array<ChallengeListInner>;
}

/**
 * Check if a given object implements the PostId200ResponseAllOf interface.
 */
export function instanceOfPostId200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostId200ResponseAllOfFromJSON(json: any): PostId200ResponseAllOf {
    return PostId200ResponseAllOfFromJSONTyped(json, false);
}

export function PostId200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostId200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : ((json['result'] as Array<any>).map(ChallengeListInnerFromJSON)),
    };
}

export function PostId200ResponseAllOfToJSON(value?: PostId200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result === undefined ? undefined : ((value.result as Array<any>).map(ChallengeListInnerToJSON)),
    };
}

